import Icon from '../components/Icon.vue'

Icon.register({
  'chess-rook': {
    width: 384,
    height: 512,
    paths: [
      {
        d: 'M81.2 215l-45.4-42.3c-2.4-2.3-3.8-5.5-3.8-8.8v-119.9c0-6.6 5.4-12 12-12h40c6.6 0 12 5.4 12 12v44h48v-44c0-6.6 5.4-12 12-12h72c6.6 0 12 5.4 12 12v44h48v-44c0-6.6 5.4-12 12-12h40c6.6 0 12 5.4 12 12v119.9 0c0 2.9-1.7 6.8-3.8 8.8l-45.4 42.3c0.3 44.1 3.8 133.4 33.2 233h-288c29.4-99.9 33-189.1 33.2-233zM160 256v64h64v-64c0-17.7-14.3-32-32-32s-32 14.3-32 32zM384 476v24c0 6.6-5.4 12-12 12h-360c-6.6 0-12-5.4-12-12v-24c0-6.6 5.4-12 12-12h360c6.6 0 12 5.4 12 12z'
      }
    ]
  }
})
